export const views = {
  advertiserList: {
    title: '広告主一覧',
  },
}
